<template>
  <b-navbar type="dark" variant="dark" class="border-bottom shadow-sm">
      <b-navbar-brand class="m-auto">Pazzle</b-navbar-brand>
  </b-navbar>
</template>

<script>
export default {}
</script>